import { DietaryRequirementsService } from "@/clients/services/DietaryRequirementsService";
import { QueryKeys } from "@/constants/query-keys";
import { useQuery } from "@tanstack/react-query";

export const useGetDietaryRequirementOptions = () => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [QueryKeys.DIETARY_REQUIREMENT_OPTIONS],
    queryFn: async () => {
      const { data } =
        await DietaryRequirementsService.getDietaryRequirementsOptionsApiV1DietaryRequirementsOptionsGet();
      return data?.dietaryRequirementOptions ?? [];
    },
  });

  return {
    dietaryOptions: data,
    isLoading,
    isError,
    error,
  };
};
